var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editPinnedMsg }
            },
            [_vm._v("Edit Pinned Message")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.pinnedMsg
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pinnedMsg.corpAdminMessageId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Corporation")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pinnedMsg.corporationName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Message")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pinnedMsg.corpAdminMessage))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Create By")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pinnedMsg.msgSenderName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Date")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.pinnedMsg.msgSentDateFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.pinnedMsg.active == "0"
                  ? _c("td", [_vm._v("Inactive")])
                  : _c("td", [_vm._v("Active")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Pinned Message Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-048eb03c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048eb03c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/PinnedMsgs/PinnedMsgDetails.vue
// module id = SHol
// module chunks = 0